import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { SurveyResponse } from 'app/models/survey-response';
import { Survey, SurveyKey } from 'app/models/feedback-question';
import { AgentId } from 'app/models/agents';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private readonly apiVersion: string = `v1/ad/`;
  private readonly apiVersion2: string = `v1/`; // TODO: unify api versions

  constructor(private apiService: ApiService) {}

  private getApiVersion(agentId: AgentId): string {
    switch (agentId) {
      case AgentId.ANOMALY_DETECTION:
        return 'v1/ad/';
      case AgentId.COA_MAPPING:
        return 'v1/coa/';
      case AgentId.TRIAL_BALANCE:
        return 'v1/tbe/';
      default:
        throw new Error(`Unknown agent ID: ${agentId}`);
    }
  }

  getSurvey(surveyKey: SurveyKey): Observable<Survey> {
    const slug: string =
      `${this.getApiVersion(surveyKey.agentId)}` +
      `survey/${surveyKey.projectId}`;

    return this.apiService.get(slug, {}, '');
  }

  getAllSurveys(agentId: AgentId): Observable<any> {
    const slug: string = `${this.getApiVersion(agentId)}` + `surveys/all`;
    return this.apiService.get(slug, {}, '');
  }

  getSurveyResponses(agentId: AgentId, surveyId: string): Observable<any> {
    const slug: string =
      `${this.getApiVersion(agentId)}` + `survey/${surveyId}/responses`;
    return this.apiService.get(slug, {}, '');
  }

  getMeRole(projectId: string): Observable<any> {
    const slug: string = `v1/core/me`;
    return this.apiService.get(slug, {}, '');
  }

  exportSurvey(
    agent: string,
    min_date: string,
    max_date: string
  ): Observable<any> {
    const slug: string =
      `${this.apiVersion2}` + `${agent}` + `/surveys/all/export`;
    return this.apiService.get(slug, { min_date, max_date }, '', {
      responseType: 'blob',
    });
  }

  postFeedback(
    surveyKey: SurveyKey,
    surveyResponse: SurveyResponse
  ): Observable<any> {
    const slug: string =
      `${this.getApiVersion(surveyKey.agentId)}` +
      `survey/${surveyKey.projectId}`;

    const answers = surveyResponse.answers;
    const data = { answers };
    return this.apiService.post(slug, data, '');
  }
}
